import { E } from '@angular/cdk/keycodes';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { Configuration } from 'app/app.configuration';
import { ToastrService } from 'ngx-toastr';
import { DataService } from '../helper/http-service';
import { ParseService } from '../parse/parse.service';
import { StorageConfiguration } from '../storage-setting/storage-configuration';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-inviting-user',
  templateUrl: './inviting-user.component.html',
  styleUrls: ['./inviting-user.component.scss']
})
export class InvitingUserComponent implements OnInit {
  invitingUserForm: any;
  tenantId: any;
  projectList = [{
    value: 'ERP',
    label: 'ERP'
  }];
  projects: any;
  profileId: any;
  selectedProject: any;
  ProjectId: string;
  ProjectName: any;
  locationId: string;
  organizationId: string;
  projectAssignedList: any = [];
  unassignedProjectId: string;

  constructor(
    private formBuilder: FormBuilder,
    private configuration: Configuration,
    private dataService: DataService,
    private storageConfiguration: StorageConfiguration,
    public parseService: ParseService,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {

    this.invitingUserForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      project: ['', Validators.required],
      isDefaultTaskSelected: true,
      isWebDesktop: [true]
    });
  }

  ngOnInit(): void {
    this.profileId = this.parseService.instance.User.current().get('profile').id;
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.getProjects();
    this.getLocation();
    this.getOrigination();
    this.getUnassignedProject();
  }

  onInviteUser(): void {
    // console.log(this.invitingUserForm.value);
    if (this.invitingUserForm.status !== 'INVALID') {
      this.spinner.show();
      this.checkEmailAlreadyExist();
    } else {
      this.toastr.error('Please Enter The Details');
    }
  }

  getUnassignedProject() {
    const Project = this.parseService.instance.Object.extend('Project');
    const project = new this.parseService.instance.Query(Project);
    project.equalTo('projectInfo.projectName', 'Unassigned Project');
    project.equalTo('tenantId', this.tenantId);
    project.find().then(res => {
      this.unassignedProjectId = res[0].id;
      this.projectAssignedList.push(res[0].id);
    });
  }

  // check email already exists
  checkEmailAlreadyExist(): void {
    const User = this.parseService.instance.Object.extend('_User');
    const userQuery = new this.parseService.instance.Query(User);
    userQuery.equalTo('email', this.invitingUserForm.get('email').value.toLowerCase());
    userQuery.include('profile');
    userQuery.find().then(res => {
      const userData = res[0];
      if (userData !== undefined) {
        this.toastr.error('Email Already Exist.');
        this.spinner.hide();
      }
      else if (userData === undefined) {
        this.sendEmailToInvitedUser();
      }
    });
  }

  onProjectChange(selected): void {
    this.selectedProject = selected.value;
  }

  async getProjects(): Promise<void> {
    this.projects = [];
    const profileClass = this.parseService.instance.Object.extend('Project');
    const query = new this.parseService.instance.Query(profileClass);
    query.equalTo('defaultProject', false);
    // query.containedIn('projectInfo.currentStatus', ['New', 'In Progress']);
    query.equalTo('tenantId', this.tenantId);
    query.limit(100000);
    query.find().then((datas: any) => {
      for (let data of datas) {
        const obj = {
          projectId: data.id,
          projectName: data.get('projectInfo').projectName,
          schedulerStatus: data.get('schedulerStatus')
        };
        this.projects.push(obj);
      }
    });
    // console.log(this.projects);
  }

  async sendEmailToInvitedUser(): Promise<void> {
    const InvitedMemberEmailData = [this.invitingUserForm.get('email').value.toLowerCase()];
    this.ProjectId = this.invitingUserForm.get('project').value.projectId;
    this.ProjectName = this.invitingUserForm.get('project').value.projectName;
    this.dataService.add(this.configuration.inviteMembers + '?tenantId=' + this.tenantId + '&profileId=' + this.profileId + '&projectId=' + this.ProjectId, InvitedMemberEmailData)
      .subscribe((data: any) => {
        this.InvitedUserProfileCreation();
      }, error => {
        this.spinner.hide();
        // console.log('error', error);
      });
  }

  async InvitedUserProfileCreation(): Promise<void> {
    const InvitedUserEmailId = this.invitingUserForm.value.email.toLowerCase();
    const InvitedUserName = InvitedUserEmailId.substring(0, InvitedUserEmailId.lastIndexOf('@'));
    const Profile = this.parseService.instance.Object.extend('Profile');
    const profile = new Profile();
    profile.set('firstName', InvitedUserName);
    profile.set('lastName', InvitedUserName);
    profile.set('username', InvitedUserName);
    profile.set('email', InvitedUserEmailId);
    profile.set('screenShot', true);
    profile.set('reportingTo', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
    profile.set('password', 'SmartWork@123');
    profile.set('isActive', true);
    profile.set('isLongLeave', false);
    profile.set('departmentHistory', []);
    profile.set('locationHistory', []);
    profile.set('organisationHistory', []);
    profile.set('reporterHistory', []);
    profile.set('personalInfo', { 'mobileNo': '' });
    profile.set('skillSet', []);
    profile.set('resignationInfo', {});
    profile.set('profileImageInfo', {});
    profile.set('officialInfo', { 'startTime': '9:30 AM', 'officialEmail': InvitedUserEmailId });
    profile.set('systemInfo', {});
    profile.set('experienceInfo', []);
    profile.set('userStatus', 'Away');
    profile.set('status', 'Pending');
    profile.set('tenantId', this.tenantId);
    profile.set('location', { __type: 'Pointer', className: 'Location', objectId: this.locationId });
    profile.set('screenShotSyncTime', 300);
    profile.set('organisation', { __type: 'Pointer', className: 'Organisation', objectId: this.organizationId });
    // location.id = 'jMdBjPBQUj'; // default location as indian
    profile.set('department', { __type: 'Pointer', className: 'Department', objectId: 'vDwe5wcsAX' });
    profile.set('isWebDesktop', this.invitingUserForm.value.isWebDesktop);
    // Role Info
    const roleHistory = [];
    const roleHistoryInfo = {
      id: 'pfBmtj09sE',
      name: 'Software Engineer',
      startDate: new Date(),
      endDate: '',
      isActive: true
    };
    roleHistory.push(roleHistoryInfo);
    profile.set('roleHistory', roleHistory);
    const role = new this.parseService.instance.Object('_Role');
    role.id = 'pfBmtj09sE';
    // this.roleId = role.id;
    profile.set('role', role);
    await profile.save().then(async (result) => {

      this.InvitedUserCreation(result.id, InvitedUserName, InvitedUserEmailId);

      if (this.invitingUserForm.get('isDefaultTaskSelected').value) {
        let sprintId;
        await this.getProjectSpritDetails().then((sprint) => {
          if (sprint !== undefined) { sprintId = sprint.id; }
        });
        let boardId;
        await this.getProjectBoardLists().then((board) => {
          if (board !== undefined) { boardId = board.id; }
        });
        this.saveDefaultTasks(result.id, sprintId, boardId);
      }
    });

  }

changeDesktopType(val): void {
  this.invitingUserForm.value.isWebDesktop = val;
  this.invitingUserForm.isWebDesktop = val;
}

  async getProjectSpritDetails(): Promise<any> {
    const Sprint = this.parseService.instance.Object.extend('Sprint');
    const sprintQuery = new this.parseService.instance.Query(Sprint);
    // sprintQuery.equalTo('tenantId', this.tenantId);
    sprintQuery.equalTo('name', 'Backlogs');
    sprintQuery.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: this.ProjectId });
    const result = await sprintQuery.find();
    return await result[0];
  }

  async getProjectBoardLists(): Promise<any> {
    const ProjectBoardLists = this.parseService.instance.Object.extend('ProjectBoardLists');
    const projectBoardListsQuery = new this.parseService.instance.Query(ProjectBoardLists);
    projectBoardListsQuery.equalTo('name', 'Backlogs');
    projectBoardListsQuery.equalTo('project', this.ProjectId);
    const result = await projectBoardListsQuery.find();
    return await result[0];
  }

  async InvitedUserCreation(profileId, InvitedUserName, InvitedUserEmailId): Promise<void> {
    const User = this.parseService.instance.Object.extend('User');
    const user = new User();
    user.set('profile', { __type: 'Pointer', className: 'Profile', objectId: profileId });
    user.set('firstName', InvitedUserName);
    user.set('lastName', InvitedUserName);
    user.set('username', InvitedUserName);
    user.set('email', InvitedUserEmailId);
    user.set('password', 'SmartWork@123');
    user.set('isActive', true);
    user.set('employeeId', '');
    user.set('role', { __type: 'Pointer', className: '_Role', objectId: 'pfBmtj09sE' });
    user.set('tenantId', this.tenantId);
    // user.set('role', { __type: 'Pointer', className: '_Role', objectId: '7H5KZezYip' });
    await user.save().then((data) => {
      this.InvitedUserProjectMemberCreation(InvitedUserName, data.id);
    });

  }

  async InvitedUserProjectMemberCreation(InvitedUserName, userId): Promise<void> {
    let chooseProjectId = this.invitingUserForm.get('project').value.projectId;
    this.projectAssignedList.push(chooseProjectId);
    for (let projectId of this.projectAssignedList) {
      const ProjectMember = this.parseService.instance.Object.extend('ProjectMembers');
      const projectMember = new ProjectMember();
      projectMember.set('project', { __type: 'Pointer', className: 'Project', objectId: projectId });
      projectMember.set('startDate', new Date());
      projectMember.set('endDate', new Date());
      projectMember.set('resourcesType', this.selectedProject.schedulerStatus);
      projectMember.set('username', InvitedUserName);
      projectMember.set('isActive', true);
      projectMember.set('status', 'Assigned');
      projectMember.set('role', 'Full-Stack');
      projectMember.set('tenantId', this.tenantId);
      projectMember.set('Hours', 0);
      projectMember.set('Month', 0);
      projectMember.set('isInvited', true);
      projectMember.set('user', { __type: 'Pointer', className: '_User', objectId: userId });
      await projectMember.save().then(() => {
        if (!this.unassignedProjectId) {
          this.toastr.success('Invited Email send successfully');
        }
        this.InvitedUserDefaultTaskCreation();
        this.invitingUserForm.reset();
        this.spinner.hide();
        this.getProjects();
      });

    }
  }

  async InvitedUserDefaultTaskCreation(): Promise<void> {
    this.dialog.closeAll();
  }

  async saveDefaultTasks(profileId, sprintId, boardId): Promise<any> {
    const DefaultTask = this.parseService.instance.Object.extend('DefaultTask');
    const defaultTaskQuery = new this.parseService.instance.Query(DefaultTask);
    defaultTaskQuery.equalTo('tenantId', this.tenantId);
    let defaultTaskList = await defaultTaskQuery.find();
    const defaultTaskData = JSON.parse(JSON.stringify(defaultTaskList[0]));
    defaultTaskList = defaultTaskData.defaultTasks;

    for (const element of defaultTaskList) {
      const Tasks = this.parseService.instance.Object.extend('Tasks');
      const task = new Tasks();
      task.set('dueDate', new Date());
      task.set('startDate', new Date());
      task.set('isActive', true);
      task.set('title', element.defaulttask);
      task.set('Project', { __type: 'Pointer', className: 'Project', objectId: this.ProjectId });
      task.set('taskCheckList', []);
      task.set('cardType', 'Backlog');
      task.set('description', element.defaulttask);
      task.set('comments', []);
      task.set('taskRole', []);
      task.set('taskType', ['Medium']);
      task.set('typeOfTask', []);
      task.set('attachments', []);
      task.set('priority', '');
      task.set('activities', []);
      task.set('idAttachmentCover', '');
      task.set('storyPoints', '');
      task.set('estimatedHours', 3600);
      task.set('completedHours', 0);
      task.set('syncTime', 0);
      task.set('taskStatus', 'Not yet Started');
      task.set('isAllocated', false);
      task.set('assigneesId', [profileId]);
      task.set('userPlannedStatus', 'new');
      task.set('cardNumber', Number(this.getRandomNumber(4)));
      task.set('tenantId', this.tenantId);
      task.set('sprintId', { __type: 'Pointer', className: 'Sprint', objectId: sprintId });
      task.set('projectName', this.ProjectName);
      if (boardId) {
        task.set('scrumboardList', { __type: 'Pointer', className: 'ProjectBoardLists', objectId: boardId });
      }
      task.set('taskUpdatedTime', {
        "todoDate": "",
        "inProgressDate": "",
        "completedDate": "",
        "readyForQaDate": "",
        "reOpenDate": "",
        "closedDate": ""
      });
      task.set('todoDateActivity', []);
      task.set('inProgressDateActivity', []);
      task.set('completedDateActivity', []);
      task.set('readyForQaDateActivity', []);
      task.set('reOpenDateActivity', []);
      task.set('closedDateActivity', []);
      task.set('defaultTask', true);
      task.save();
    }
  }

  getRandomNumber(val) {
    const timestamp = +new Date();
    length = val;
    var ts = timestamp.toString();
    var parts = ts.split('').reverse();
    var id = '';

    for (var i = 0; i < length; ++i) {
      var index = this.generateRandomNumber(0, parts.length - 1);
      id += parts[index];
    }
    return id;
  }

  generateRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  async getLocation() {
    let queryInstance = this.parseService.instance.Object.extend('Location');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('tenantId', this.tenantId);
    query.equalTo('name', 'Default Location');
    let invitedUser = await query.find();
    this.locationId = invitedUser[0].id;
  }

  async getOrigination() {
    let Organisation = this.parseService.instance.Object.extend('Organisation');
    let organization = new this.parseService.instance.Query(Organisation);
    organization.equalTo('tenantId', this.tenantId);
    organization.equalTo('name', 'Default Organization');
    let org = await organization.find();
    this.organizationId = org[0].id;
  }

}
